import { useTranslation } from 'react-i18next';
import CabeceraPagina from '../Compartido/CabeceraPagina.jsx';
import limpiarHtml from '../Compartido/limpiarHtml.js';

const TextoNoticia = ({ noticia, ruta }) => {

    const { t } = useTranslation();

    const segmento = window.location.pathname.split('/')[1];
    const preidioma = /^(en|fr|it|pt|ru|de|sv|ca|cs|nl)$/.test(segmento) ? segmento + '/' : '';

    return (
        <>
            <CabeceraPagina
                titulo={noticia.eltitulo}
                eyebrow={t("Blog")}
                migas={[
                    { label: t("Inicio"), href: "/" + preidioma },
                    { label: t("Blog"), href: "/" + preidioma + t("blog") },
                    { label: noticia.eltitulo },
                ]}
                imagen={noticia.imagen ? ruta + "/blog/" + noticia.id + "/" + noticia.imagen : null}
            />
            <article className="bhe-prose">
                {noticia.fecha_publica && (
                    <div className="bhe-meta"><i className="fa-regular fa-calendar"></i> {noticia.fecha_publica}</div>
                )}
                <div className="bhe-lead" dangerouslySetInnerHTML={{ __html: limpiarHtml(noticia.ladesccorta) }}></div>
                <div dangerouslySetInnerHTML={{ __html: limpiarHtml(noticia.ladesclarga) }}></div>
            </article>
        </>
    );
}

export default TextoNoticia;
